export default "__VITE_PUBLIC_ASSET__5db532da__"